{
"catalog": {
" company has been added": " bedrijf is toegevoegd",
" day. Renew now to continue enjoying uninterrupted access.": " dag. Verleng nu om ononderbroken toegang te blijven genieten.",
" days. Renew now to continue enjoying uninterrupted access.": " dagen. Verleng nu om ononderbroken toegang te blijven genieten.",
"(\u00d8re/kWh)": "(\u00d8re/kWh)",
"0.00": "0,00",
": The new company has been added": ": Het nieuwe bedrijf is toegevoegd",
"A code of reference ( Who referred a company)": "Een referentiecode (wie verwees naar een bedrijf)",
"A link has been sent to your email address to reset password": "Er is een link naar je e-mailadres gestuurd om je wachtwoord opnieuw in te stellen",
"A link has been sent to your email address to reset password.": "Er is een link naar uw e-mailadres gestuurd om uw wachtwoord opnieuw in te stellen.",
"A newer version of this application is available. The update will begin automatically in 20 seconds.": "Er is een nieuwere versie van deze applicatie beschikbaar. De update begint automatisch na 20 seconden.",
"A suspicious activity was detected. For security reasons, you must log in again": "Er is een verdachte activiteit gedetecteerd. Om veiligheidsredenen moet u opnieuw inloggen",
"API Documentation": "API-documentatie",
"API Key": "API sleutel",
"API key": "API key",
"Access from partner website": "Toegang vanaf partnerwebsite",
"Access given": "Toegang gegeven",
"Access is Required!": "Toegang is vereist!",
"Access period": "Toegangsperiode",
"Account Setup": "Account instellen",
"Account creation code": "Aanmaakcode account",
"Actions": "Acties",
"Active": "Actief",
"Active Users": "Actieve gebruikers",
"Active Users List": "Lijst met actieve gebruikers",
"Add": "Toevoegen",
"Add Contract": "Contract toevoegen",
"Add Corporate Group": "Bedrijfsgroep toevoegen",
"Add Customer": "Klant toevoegen",
"Add Document": "Voeg Document toe",
"Add Historical Data Limit": "Historische gegevenslimiet toevoegen",
"Add New Corporate Group": "Nieuwe bedrijfsgroep toevoegen",
"Add New Feature": "Nieuwe Eigenschap Toevoegen",
"Add New Module": "Nieuwe module toevoegen",
"Add New Partner": "Nieuwe partner toevoegen",
"Add New Subscription": "Voeg een nieuw abonnement toe",
"Add New User": "Voeg nieuwe gebruiker toe",
"Add Partner": "Partner toevoegen",
"Add User": "Gebruiker toevoegen",
"Add a new role": "Een nieuwe rol toevoegen",
"Add company": "Bedrijf toevoegen",
"Add contract": "Voeg contract toe",
"Add feature": "Kenmerk toevoegen",
"Add permission": "Voeg toestemming toe",
"Add role": "Rol toevoegen",
"Add subscription plan": "Abonnementsplan toevoegen",
"Address": "Adres",
"Aggregated": "Geaggregeerd",
"Aggregation": "Aggregatie",
"Alias": "Alias",
"All": "Alle",
"All Documents": "Alle Documenten",
"All Partners": "Alle partners",
"All Users": "Alle gebruikers",
"All kWh": "Alle kWh",
"All notifications deleted successfully": "Alle meldingen zijn succesvol verwijderd",
"All notifications marked as read": "Alle meldingen gemarkeerd als gelezen",
"Alpha numeric and dash only": "Alleen alfanumerieke tekens en streepjes",
"Already have an account?": "Heb je al een account?",
"Amount of money for consumption": "Geldbedrag voor consumptie",
"An error occurred while deleting the document": "Er is een fout opgetreden tijdens het verwijderen van het document.",
"An error occurred while the system was generating the report. Please try again. You can contact support If this continues.": "Er is een fout opgetreden tijdens het genereren van het rapport. Probeer het opnieuw. U kunt contact opnemen met support als dit probleem zich blijft voordoen.",
"An unexpected error occurred. It has been logged, and we are working on a resolution.": "Er heeft zich een onverwachte fout voorgedaan. De fout is gelogd en we werken aan een oplossing.",
"Annual CO\u2082e (Kg)": "Jaarlijkse CO\u2082e (kg)",
"Annual Statement": "Jaarlijkse verklaring",
"Annual energy consumption (kWh)": "Jaarlijks energieverbruik (kWh)",
"App": "App",
"App URL": "App-URL",
"Apr": "Apr",
"Apr: Checking": "Apr: Controleren",
"Apr: Get": "Apr: Krijg",
"Apr: Update": "Apr: Update",
"April": "April",
"Are you sure you want to delete this notification ? ": "Weet u zeker dat u deze melding wilt verwijderen? ",
"Are you sure you want to delete?": "Weet je het zeker dat je het wilt verwijdern?",
"Attach Company with User": "Bedrijf met gebruiker toevoegen",
"Aug": "Aug",
"Aug: Checking": "Aug: Controleren",
"Aug: Get": "Aug: Krijg",
"Aug: Update": "Aug: Update",
"August": "Augustus",
"Authority Processing": "Autoriteit Verwerking",
"Authorization": "Authorisatie",
"Availability Payment": "Beschikbaarheid Betaling",
"Availability Rate": "Beschikbaarheidspercentage",
"Back": "Terug",
"Back to": "Terug naar",
"Back to Documents": "Terug naar documenten",
"Basic Information": "Basis informatie",
"Before getting started, could you verify your email address by ": "Voordat je begint, kun je je e-mailadres verifi\u00ebren door ",
"Blocked": "Geblokkeerd",
"Building": "Gebouw",
"Building address": "Adres gebouw",
"Building is required": "Bouwen is vereist",
"But you still need to know more.": "Maar je moet nog steeds meer weten.",
"CAPTCHA verification failed. Please try again.": "CAPTCHA-verificatie mislukt. Probeer het opnieuw.",
"CCPA Privacy Rights (Do Not Sell My Personal Information)": "CCPA-privacyrechten (mijn persoonlijke gegevens niet verkopen)",
"CO\u2082_per_m2": "CO\u2082_per_m2",
"CO\u2082e": "CO\u2082e",
"CO\u2082e (Kg)": "CO\u2082e (kg)",
"CVR": "CVR",
"Cached": "In cache opgeslagen",
"Cancel": "Annuleren",
"Carbon Emissions (Kg CO\u2082e)": "Koolstofemissies (kg CO\u2082e)",
"Carbon Footprint (g CO\u2082e/kWh)": "Koolstofvoetafdruk (g CO\u2082e/kWh)",
"Carbon dioxide Consumption": "Kooldioxide Verbruik",
"Cashed Statement - Under Development": "Verzilverde verklaring - In ontwikkeling",
"Central business Register number": "Centraal bedrijfsregisternummer",
"Change Password": "Wachtwoord wijzigen",
"Change password": "Wachtwoord wijzigen",
"Checking Cache": "Cache controleren",
"Child Company": "Dochteronderneming",
"Child company and above level access": "Toegang tot dochteronderneming en hoger niveau",
"City": "Stad",
"Clear above cache": "Cache wissen",
"Clear all cache": "Alle cache wissen",
"Clear browser memory / Page reload": "Browsergeheugen wissen / Pagina opnieuw laden",
"Click to copy": "Klik om te kopi\u00ebren",
"Click to upload or drag and drop": "Klik om te uploaden of sleep het bestand naar de juiste plek.",
"Climate": "Klimaat",
"Climate report": "Klimaatrapport",
"Close": "Sluiten",
"Co2 Certificates": "CO2-certificaten",
"Code": "Code",
"Coming Soon": "Binnenkort beschikbaar",
"Commission Price": "Commissie prijs",
"Commission Share": "Commissie",
"Companies": "Bedrijven",
"Companies for ": "Bedrijven voor ",
"Companies for the corporate group: ": "Bedrijven voor de ondernemingsgroep: ",
"Company": "Bedrijf",
"Company Authenticity number": "Bedrijfsauthenticiteitsnummer",
"Company Name": "Bedrijfsnaam",
"Company No.": "Bedrijfsnr.",
"Company Number": "Ondernemingsnummer",
"Company Roles": "Bedrijfsrollen",
"Company Users for ": "Bedrijfsgebruikers voor ",
"Company name": "Bedrijfsnaam",
"Company website": "Bedrijfswebsite",
"Compensation": "Vergoeding",
"Confirm Email Address": "Bevestig e-mailadres",
"Confirm Password": "Bevestig wachtwoord",
"Confirm Password is required": "Bevestigen dat wachtwoord is verplicht",
"Confirm password does not match.": "Wachtwoord komt niet overeen met de bevestiging.",
"Confirmation": "Bevestiging",
"Congratulations, you\u2019ve chosen the best energy spending platform": "Gefeliciteerd, je hebt het beste platform voor energie-uitgaven gekozen",
"Consent": "Toestemming",
"Consumption": "Verbruik",
"Consumption (kWh)": "Verbruik (kWh)",
"Consumption and CO\u2082e": "Verbruik en CO\u2082e",
"Consumption is kWh": "Verbruik is kWh",
"Consumption measured in kWh": "Verbruik gemeten in kWh",
"Contact Name": "Contact naam",
"Contact Phone": "Contact telefoon",
"Continue": "Doorgaan",
"Contract list": "Contractenlijst",
"Contracts": "Contracten",
"Conversion Rate": "Conversie percentage",
"Conversion Rate for CO\u2082e": "Omrekeningskoers voor CO\u2082e",
"Conversion rate in g CO\u2082e/kWh": "Conversiesnelheid in g CO\u2082e/kWh",
"Copied to clipboard": "Gekopieerd naar klembord",
"Corporate Group": "Bedrijfsgroep",
"Corporate Groups": "Bedrijfsgroepen",
"Corporate Groups for the partner ": "Bedrijfsgroepen voor de partner ",
"Corporate group and above level access": "Toegang op bedrijfsgroepniveau en hoger",
"Cost": "Kosten",
"Cost (DKK)": "Kosten (DKK)",
"Cost in DKK": "Kosten in DKK",
"Country": "Land",
"Country code": "Landcode",
"Country, Timezone and Corporate Group is Required!": "Land, tijdzone en bedrijfsgroep zijn vereist!",
"Create Historical Data Limit": "Historische gegevenslimiet aanmaken",
"Create New Contract": "Nieuw contract maken",
"Create a new password": "Maak een nieuw wachtwoord",
"Create or get an API key to access your data.": "Maak of krijg een API-sleutel om toegang te krijgen tot je gegevens.",
"Created At": "Aangemaakt op",
"Created By": "Aangemaakt door",
"Currency": "Valuta",
"Currency is required": "Valuta is vereist",
"Current Password": "Huidig Wachtwoord",
"Current month only": "Alleen huidige maand",
"Current year only": "Alleen lopend jaar",
"Customer": "Klant",
"DKK": "DKK",
"Daily": "Dagelijks",
"Danish": "Deens",
"Data Delivered By": "Gegevens geleverd door",
"Data granularity. PT1H = every 1 hour, PT15M = every 15 minutes": "Gegevens granulariteit. PT1H = elk 1 uur, PT15M = elke 15 minuten",
"Data is currently being loaded. Please hold on a moment.": "De gegevens worden momenteel geladen. Een ogenblik geduld alstublieft.",
"Data validation - consumption": "Validatie van gegevens - verbruik",
"DataHub": "DataHub",
"Date": "Datum",
"Date when the access is given": "Datum waarop de toegang is verleend",
"Day": "Dag",
"Day Report - Under development": "Dagrapport - In ontwikkeling",
"Days": "Dagen",
"Dear {{user_full_name}}": "Beste {{user_full_name}}",
"Dec": "Dec",
"Dec: Checking": "Dec: Controleren",
"Dec: Get": "Dec: Krijgen",
"Dec: Update": "Dec: Update",
"December": "december",
"Delete": "Verwijderen",
"Delete API Key": "API-sleutel verwijderen",
"Delete All Notifications": "Alle meldingen verwijderen",
"Deleted": "Verwijderd",
"Description": "Omschrijving",
"Developer": "Ontwikkelaar",
"Did you forget your password? Create a new one by clicking the button below.": "Ben je je wachtwoord vergeten? Maak een nieuw wachtwoord aan door op de knop hieronder te klikken.",
"Did you get this email by mistake? If so no worries - you can just ignore it.": "Heb je deze e-mail per ongeluk ontvangen? Als dat zo is, maak je dan geen zorgen - je kunt hem gewoon negeren.",
"Difference": "Verschil",
"Discount Net Tariff": "Korting netto tarief",
"Discount Subscription": "Korting abonnement",
"Distribution": "Distributie",
"District Heating": "Stadsverwarming",
"Do you know?": "Wist u?",
"Do you want to delete the document?": "Wilt u het document verwijderen?",
"Do you want to delete the historical data limit?": "Wilt u de limiet voor historische gegevens verwijderen?",
"Do you want to delete the notification?": "Wil je de melding verwijderen?",
"Do you want to unlink the company?": "Wil je het bedrijf loskoppelen?",
"Do you want to unlink the user?": "Wil je de gebruiker ontkoppelen?",
"Document Details": "Documentdetails",
"Document For": "Document voor",
"Document Preview": "Documentvoorbeeld",
"Document Type": "Documenttype",
"Document Uploading Failed": "Uploaden van document mislukt",
"Document deleted successfully": "Document succesvol verwijderd",
"Document list": "Documentenlijst",
"Document not found": "Document niet gevonden",
"Document updated successfully": "Document succesvol bijgewerkt",
"Document uploaded successfully": "Succesvol ge\u00fcpload document",
"Documents": "Documenten",
"Don't Have An Account Yet?": "Heb je nog geen account?",
"Download": "Download",
"Download Climate Report": "Klimaatrapport downloaden",
"Download Cost Report": "Download kostenoverzicht",
"Download Document": "Document downloaden",
"Download Energy Report": "Energierapport downloaden",
"Download For App": "Downloaden voor app",
"Download For WWW": "Downloaden voor WWW",
"Download Sport Price Report": "Download Sport Prijs Rapport",
"Download report": "Download rapport",
"Drag and drop files here or click": "Sleep bestanden hierheen of klik",
"Drop the file here or": "Drop het bestand hier of",
"Dutch": "Nederlands",
"EPAD": "EPAD",
"EPAD Price": "EPAD Prijs",
"EPAD Share": "Aandeel EPAD",
"EPAD Type": "Type EPAD",
"EPAD kWh": "EPAD kWh",
"Edit": "Bewerken",
"Edit Contract": "Contract bewerken",
"Edit Corporate Group": "Bedrijfsgroep bewerken",
"Edit Document Details": "Documentgegevens bewerken",
"Edit Feature": "Bewerk Eigenschap",
"Edit Historical Data Limit": "Limiet historische gegevens bewerken",
"Edit Module": "Bewerk module",
"Edit Partner": "Bewerk partner",
"Edit Role": "Rol bewerken",
"Edit Subscription": "Abonnement bewerken",
"Edit User": "Bewerk gebruiker",
"Edit User Company": "Gebruikersbedrijf bewerken",
"Effect Payment": "Effect Betaling",
"Effortless energy insights at your fingertips": "Moeiteloos inzicht in energie binnen handbereik",
"Ekskl. moms": "Exclusief btw",
"Electricity": "Elektriciteit",
"Electricity Charge": "Elektriciteitskosten",
"Electricity consumption": "Elektriciteitsverbruik",
"Electricity measured in kWh": "Elektriciteit gemeten in kWh",
"Email": "E-mail",
"Email Not Verified": "E-mail niet geverifieerd",
"Email Sent ": "E-mail verzonden ",
"Email address": "E-mailadres",
"Email is required.": "E-mailadres is verplicht.",
"End": "Einde",
"End Date": "Einddatum",
"Energy": "Energie",
"Energy Consumption (kWh)": "Energieverbruik (kWh)",
"Energy Contract": "Energiecontract",
"Energy Type": "Energietype",
"Energy report": "Energierapport",
"Energy type is required": "Energietype is vereist",
"English": "Engels",
"Enter description": "Vul een beschrijving in",
"Enter email": "Voer e-mailadres in",
"Enter email address": "Voer een e-mailadres in",
"Enter email address to continue.": "Voer uw e-mailadres in om door te gaan.",
"Enter full name": "Voer de volledige naam in",
"Enter name": "Vul de naam in",
"Enter password": "Vul je wachtwoord in",
"Enter password again": "Voer je nieuwe wachtwoord nogmaals in",
"Enter your new password to reset": "Voer je nieuwe wachtwoord in om te resetten",
"Error loading image:": "Fout bij het laden van de afbeelding:",
"Error: Something went wrong!": "Fout: Er ging iets mis!",
"Error: Something went wrong! ": "Fout: Er ging iets mis! ",
"Excel Reports": "Excel-rapporten",
"Excel Update": "Excel-update",
"Expire At": "Verlopen op",
"Export": "Exportieren",
"Export to Excel": "Exporteer naar Excel",
"Fabeke": "Fabeke",
"Fabeke Data": "Fabeke gegevens",
"Fabeke follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.": "Fabeke maakt standaard gebruik van logbestanden. Deze bestanden registreren bezoekers wanneer zij websites bezoeken. Alle hostingbedrijven doen dit en het is een onderdeel van de analytics van hostingdiensten. De informatie die door logbestanden wordt verzameld, omvat internet protocol (IP)-adressen, browsertype, Internet Service Provider (ISP), datum- en tijdstempel, verwijzende/uitgaande pagina's en mogelijk het aantal klikken. Deze zijn niet gekoppeld aan informatie die persoonlijk identificeerbaar is. Het doel van deze informatie is het analyseren van trends, het beheren van de site, het volgen van de bewegingen van gebruikers op de website en het verzamelen van demografische informatie.",
"Fabeke's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.": "Het privacybeleid van Fabeke is niet van toepassing op andere adverteerders of websites. We raden u daarom aan het respectieve Privacybeleid van deze advertentieservers van derden te raadplegen voor meer gedetailleerde informatie. Het kan hun praktijken bevatten, evenals instructies over hoe u bepaalde opties kunt uitschakelen.",
"Failed to delete document": "Kan document niet verwijderen",
"Failed to load document preview. Please try downloading the document.": "Het laden van het documentvoorbeeld is mislukt. Probeer het document te downloaden.",
"Failed to unlink. ": "Ontkoppeling mislukt. ",
"Feature": "Eigenschap",
"Feature Name": "Kenmerk Naam",
"Feature key, Alpha numeric and dash only": "Functietoets, alleen alfanumeriek en streepje",
"Features": "Kenmerken",
"Features for ": "Kenmerken voor ",
"Feb": "Feb",
"Feb: Checking": "Feb: Controleren",
"Feb: Get": "Feb: Krijg",
"Feb: Update": "Feb: Update",
"February": "Februari",
"Feel free to reach out to Customer Service. They are around 24/7 to help you.": "Neem gerust contact op met de klantenservice. Zij staan 24/7 klaar om je te helpen.",
"File Name": "Bestandsnaam",
"File type not supported": "Bestandstype niet ondersteund",
"Fixed": "Vast",
"Fixed Price": "Vaste prijs",
"Fixed price": "Vaste prijs",
"Fixed price ex epad": "Vaste prijs ex epad",
"Fixed price ex epad and profile": "Vaste prijs ex epad en profiel",
"Fixed price ex profile": "Vaste prijs af profiel",
"Fixed profile ex spot": "Vast profiel af plek",
"Forgot Password": "Wachtwoord vergeten",
"Forgot Your Password?": "Wachtwoord vergeten?",
"Forgot your password?": "Wachtwoord vergeten?",
"French": "Frans",
"From": "Van",
"From date is required": "Vanaf datum is vereist",
"Full Name": "Volledige naam",
"Full Year": "Volledig jaar",
"Gain control of your energy spending": "Krijg controle over je energie-uitgaven",
"Gas": "Gas",
"Generate API Key": "Genereer API Sleutel",
"Generate Climate Report": "Klimaatrapport genereren",
"Generate Cost Report": "Kostenrapport genereren",
"Generate Email": "E-mail genereren",
"Generate Energy Report": "Energierapport genereren",
"Generate Sport Price Report": "Sportprijzenrapport genereren",
"Generating Excel file": "Excel-bestand genereren",
"German": "Duits",
"Get Full Visibility Over Your Energy Spending With Less Manual Work": "Krijg volledig zicht op uw energieverbruik met minder handmatig werk",
"Getting Data": "Gegevens ophalen",
"Go to App": "Ga naar App",
"Green Certificates": "Groene certificaten",
"Green Electricity": "Groene stroom",
"Grid company": "Netbedrijf",
"Heating": "Verwarming",
"Historical Data": "Historische gegevens",
"Historical Data Limits": "Historische gegevenslimieten",
"Hour": "Uur",
"Hour Report - Under development": "Uurrapport - In ontwikkeling",
"Hourly": "Per uur",
"Hours": "Uren",
"House No.": "Huisnr.",
"How many buildings company have": "Hoeveel gebouwen heeft het bedrijf",
"How many meters company have": "Hoeveel meters heeft het bedrijf",
"I agree with": "Ik ben het eens met",
"ID": "ID",
"If the data is heavy, it may still be loading.": "Als de gegevens zwaar zijn, worden ze mogelijk nog geladen.",
"If you want to set no limit, add 999 in the numeric field. If you want to give no access, you can handle that in the subscription plan features. However, to implement this historical data limit, you must attach it to the subscription plan.": "Als u geen limiet wilt instellen, voegt u 999 toe in het numerieke veld. Als u geen toegang wilt verlenen, kunt u dat regelen in de functies van het abonnement. Om deze limiet voor historische gegevens te implementeren, moet u deze echter aan het abonnement koppelen.",
"InActive": "Actief",
"Inkl. Moms": "Incl. moeders",
"Installation Numbers": "Installatienummers",
"Installation number": "Installatienummer",
"Installation number is required": "Installatienummer is vereist",
"Internet connection restored": "Internetverbinding hersteld",
"Interval": "Interval",
"Invite User": "Nieuwe gebruiker",
"Invoice": "Factuur",
"Invoices": "Facturen",
"It appears that no company is associated with your account.": "Het lijkt erop dat er geen bedrijf aan uw account is gekoppeld.",
"It will download a zip file containing the PO and POT files. PO file will have the existing translations, and the POT file will have the latest text that requires translation. We can use the Poedit software to import the POT text into the PO file and translate it.": "Er wordt een zipbestand gedownload dat de PO- en POT-bestanden bevat. Het PO-bestand bevat de bestaande vertalingen en het POT-bestand bevat de nieuwste tekst die vertaald moet worden. We kunnen de Poedit-software gebruiken om de POT-tekst in het PO-bestand te importeren en te vertalen.",
"Item": "Artikel",
"Items": "Items",
"Jan": "Jan",
"Jan: Checking": "Jan: Controleren",
"Jan: Get": "Jan: Krijgen",
"Jan: Update": "Jan: Update",
"January": "Januari",
"Japanese": "Japans",
"Jul": "Jul",
"Jul: Checking": "Jul: Controleren op",
"Jul: Get": "Jul: Krijg",
"Jul: Update": "Jul: Update",
"July": "Juli",
"Jun": "Jun",
"Jun: Checking": "Jun: Controleren",
"Jun: Get": "Jun: Krijg",
"Jun: Update": "Jun: Update",
"June": "Juni",
"Key": "Sleutel",
"Key, Alpha numeric and dash only": "Toets, alleen alfanumeriek en streepje",
"Kg of CO\u2082e": "Kg CO\u2082e",
"Kilogram": "Kilogram",
"LNG": "LNG",
"Language": "Taal",
"Languages": "Talen",
"Last Login": "Laatst ingelogd",
"Last Run": "Laatste run",
"Last date": "Laatste datum",
"Last seen": "Voor het laatst gezien",
"Like any other website, Fabeke uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.": "Net als elke andere website maakt Fabeke gebruik van 'cookies'. Deze cookies worden gebruikt om informatie op te slaan, waaronder bezoekersvoorkeuren en de pagina's op de website die de bezoeker heeft bezocht. De informatie wordt gebruikt om de ervaring van de gebruiker te optimaliseren door de inhoud van onze webpagina's aan te passen op basis van het browsertype en/of andere informatie van de bezoeker.",
"Link": "Link",
"Link User": "Link Gebruiker",
"Link company": "Link bedrijf",
"Link user": "Koppel gebruiker",
"List View": "Lijst weergave",
"List as": "Lijst als",
"Loading": "Laden",
"Loading security verification...": "Beveiligingscontrole wordt geladen...",
"Loading...": "Laden\u2026",
"Location": "Locatie",
"Location and above level access": "Locatie en toegang boven het maaiveld",
"Login": "Inloggen",
"Login as": "Inloggen als",
"Login code": "Inlogcode",
"Login failed! Please try again": "Inloggen mislukt! Probeer het opnieuw",
"Login successful. Redirecting.": "Inloggen gelukt. Doorverwijzen.",
"Login with your new password right away.": "Log direct in met uw nieuwe wachtwoord.",
"Main Price Type": "Hoofdprijs Type",
"Mandarin": "Mandarijn",
"Mar": "Mrt",
"Mar: Checking": "Mar: Controleren",
"Mar: Get": "Mar: Krijg",
"Mar: Update": "Mar: Update",
"March": "Maart",
"Mark As Read": "Markeer als gelezen",
"Markup": "Markup",
"Markup Price": "Prijs",
"Markup Share": "Aandeel markup",
"Max size supported 20MB": "Maximaal ondersteunde grootte 20 MB",
"Maximum 50 symbols": "Maximaal 50 symbolen",
"May": "Mei",
"May: Checking": "Mei: Controleren op",
"May: Get": "Mei: Ga naar",
"May: Update": "Mei: Update",
"Message": "Bericht",
"Meter": "Meter",
"Meter No": "Meter nr",
"Meter and above level access": "Meter en boven niveau toegang",
"Meter number": "Meter nummer",
"Meter reading end date": "Einddatum meterstand",
"Meter reading start date": "Begindatum meteropname",
"Minimum 3 symbols": "Minimaal 3 symbolen",
"Minimum Fee": "Minimum vergoeding",
"Modals": "Modals",
"Module": "Module",
"Module code, Alpha numeric and dash only": "Modulecode, alleen alfanumeriek en liggend streepje",
"Module name": "Naam module",
"Moms": "Moeders",
"Month": "Maand",
"Month Columns: Downloading": "Maand Columns: Downloaden",
"Month Columns: Processing": "Maand Kolommen: Verwerking",
"Month Data: Downloading": "Maandgegevens: Downloaden",
"Month Data: Processing": "Maandgegevens: Verwerking",
"Month Report - Under development": "Maandrapport - In ontwikkeling",
"Monthly": "Maandelijks",
"Monthly Statement": "Maandoverzicht",
"Months": "Maanden",
"Must be a valid email": "Moet een geldig e-mailadres zijn",
"My Account": "Mijn Account",
"My Companies": "Mijn bedrijven",
"My Profile": "Mijn profiel",
"Name": "Naam",
"Name is required.": "Naam is vereist.",
"Natural Gas": "Aardgas",
"Net": "Netto",
"Net Tariff": "Netto tarief",
"Never Login": "Nooit inloggen",
"New": "Nieuw",
"New Password": "Nieuw wachtwoord",
"New Password is required": "Nieuw wachtwoord is vereist",
"No": "Nee",
"No Company": "Nieuw bedrijf",
"No Documents Found": "Geen documenten gevonden",
"No Historical Data Limit": "Geen limiet voor historische gegevens",
"No Limit": "Geen limiet",
"No Partner": "Geen partner",
"No Results Found!": "Geen resultaten gevonden!",
"No Rows": "Geen rijen",
"No data found": "Geen gegevens gevonden",
"No document available for preview": "Geen document beschikbaar voor voorbeeldweergave",
"No internet connection. Please check your network.": "Geen internetverbinding. Controleer uw netwerk.",
"No option available": "Geen optie beschikbaar",
"No use of Fabeke's logo or other artwork will be allowed for linking absent a trademark license agreement.": "Het gebruik van Fabeke's logo of ander artwork voor links is niet toegestaan zonder een handelsmerklicentieovereenkomst.",
"Norwegian": "Norwegisch",
"Not Applicable": "Niet toepasbaar",
"Not Cached": "Niet in cache opgeslagen",
"Not Found": "Niet gevonden",
"Notes": "Notities",
"Notification has been deleted": "Notificatie is verwijderd",
"Notification marked as read": "Kennisgeving gemarkeerd als gelezen",
"Notifications": "Meldingen",
"Nov": "Nov",
"Nov: Checking": "Nov: Controleren",
"Nov: Get": "Nov: Krijg",
"Nov: Update": "Nov: Update",
"November": "November",
"Oct": "Okt",
"Oct: Checking": "Okt: Controleren",
"Oct: Get": "Okt: Krijg",
"Oct: Update": "Okt: Update",
"October": "Oktober",
"Official address of meter (not including location information)": "Officieel adres van de meter (zonder locatiegegevens)",
"Often the number on company's bill": "Vaak het nummer op de factuur van het bedrijf",
"Oil": "Olie",
"One Month Energy Consumption (kWh)": "Een maand energieverbruik (kWh)",
"One Month Tariff (kWh)": "Tarief per maand (kWh)",
"Only PDF files are allowed.": "Alleen PDF-bestanden zijn toegestaan.",
"Only PDF files are allowed. Leave empty to keep the existing file.": "Alleen PDF-bestanden zijn toegestaan. Laat leeg om het bestaande bestand te behouden.",
"Only for system level users": "Alleen voor gebruikers op systeemniveau",
"Only lowercase alphanumeric characters and dashes are allowed": "Alleen kleine alfanumerieke tekens en streepjes zijn toegestaan",
"Order No": "Order nr",
"Order Numbers": "Ordernummers",
"Others": "Anderen",
"Overall statement": "Algemene verklaring",
"Parameter showing Electricity consumption": "Parameter voor elektriciteitsverbruik",
"Parent Company": "Moederbedrijf",
"Parent company and above level access": "Toegang tot moedermaatschappij en hoger niveau",
"Partner": "Partner",
"Partner Users for ": "Partnergebruikers voor ",
"Partner and above level access": "Toegang voor partners en hoger",
"Partners": "Partners",
"Partnerships Team": "Partnerschapsteam",
"Password": "Wachtwoord",
"Password Changed": "Wachtwoord gewijzigd",
"Passwords didn't match": "Wachtwoorden kwamen niet overeen",
"Period/Sum": "Periode/Som",
"Permissions": "Rechten",
"Permissions for ": "machtigingen voor ",
"Personal": "Persoonlijk",
"Personal Information": "Persoonlijke informatie",
"Please also note to calculate the emission rate from CO2, the 125% method is used, which means that coproduced heat is produced by a given efficiency by 125%.": "Merk ook op dat voor de berekening van de CO2-uitstoot de 125%-methode wordt gebruikt, wat betekent dat de gecoproduceerde warmte met een bepaald rendement met 125% wordt geproduceerd.",
"Please authorize us on": "Geef ons toestemming op",
"Please enter a valid email and password!": "Voer een geldig e-mailadres en wachtwoord in!",
"Please enter a valid email!": "Voer een geldig e-mailadres in",
"Please enter a valid password!": "Voer een geldig wachtwoord in!",
"Please select a file to upload": "Selecteer een bestand om te uploaden",
"Please wait": "Even geduld",
"Please wait while security verification loads...": "Even geduld terwijl de beveiligingscontrole wordt geladen...",
"Price": "Prijs",
"Price (cent/kWh)": "Prijs (cent/kWh)",
"Price (pence/kWh)": "Prijs (pence/kWh)",
"Price (\u00d8re/kWh)": "Prijs (\u00d8re/kWh)",
"Price (\u00f8re/kWh)": "Prijs (\u00f8re/kWh)",
"Price Price": "Prijs Prijs",
"Price Share": "Prijs Aandeel",
"Price Type": "Prijs Type",
"Price elements": "Prijselementen",
"Price in (\u00d8re/kWh)": "Prijs in (\u00d8re/kWh)",
"Price kWh": "Prijs kWh",
"Price type": "Prijs type",
"Price type is required": "Prijstype is vereist",
"Prices": "Prijzen",
"Prices, tariffs, taxes and cost": "Prijzen, tarieven, belastingen en kosten",
"Privacy Policy": "Privacybeleid",
"Privacy Policy for Fabeke": "Privacybeleid voor Fabeke",
"Procurement": "Aanbesteden",
"Profile": "Profiel",
"Profile Price": "Profiel Prijs",
"Profile Share": "Profiel Aandeel",
"Profile Type": "Profiel Type",
"Profile kWh": "Profiel kWh",
"Q1": "Q1",
"Q2": "Q2",
"Q3": "Q3",
"Q4": "Q4",
"Quantity (kWh)": "Hoeveelheid (kWh)",
"Questions?": "Vragen?",
"Rabat Net Tariff": "Rabat netto tarief",
"Read All Notifications": "Lees alle meldingen",
"Read Notification": "Kennisgeving lezen",
"Ready to enhance your offering? Talk to someone from our partnerships team today & start using ": "Klaar om uw aanbod te verbeteren? Praat vandaag nog met iemand van ons partnerschapsteam & begin met het gebruik van ",
"Real-time, precise, and automated.": "Real-time, nauwkeurig en geautomatiseerd.",
"Recover Password": "Wachtwoord Ophalen",
"Registered successful. Redirecting.": "Succesvol geregistreerd. Omleiden.",
"Remove file": "Verwijder bestand",
"Report": "Rapport",
"Reports": "Rapporten",
"Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.": "Vragen dat een bedrijf dat persoonlijke gegevens van consumenten verzamelt, de categorie\u00ebn en specifieke stukken persoonlijke gegevens bekendmaakt die een bedrijf over consumenten heeft verzameld.",
"Request that a business that sells a consumer's personal data, not sell the consumer's personal data.": "Verzoek dat een bedrijf dat persoonlijke gegevens van een consument verkoopt, geen persoonlijke gegevens van de consument verkoopt.",
"Require all devices to sign in again with the new password.": "Alle apparaten moeten zich opnieuw aanmelden met het nieuwe wachtwoord.",
"Reset Completed": "Reset voltooid",
"Reset Password": "Wachtwoord opnieuw instellen",
"Reset Your Password": "Nieuw Wachtwoord Instellen",
"Role": "Rol",
"Role Specific Information": "Rolspecifieke informatie",
"Role key, Alpha numeric and dash only": "Sleuteltoets, alleen alfanumerieke tekens en streepjes",
"Roles": "Rollen",
"Save": "Opslaan",
"Save All For": "Alles opslaan voor",
"Save Changes": "Wijzigingen opslaan",
"Save Profile": "Profiel opslaan",
"Saving. Please wait.": "Opslaan. Even geduld.",
"Scraper List": "Schraper Lijst",
"Scraper Log": "Schraper Logboek",
"Scraper Name": "Naam schraper",
"Search": "Zoeken",
"See All Notifications": "Bekijk alle notificaties",
"Select": "Selecteer",
"Select Company": "Bedrijf selecteren",
"Select date range": "Selecteer datumbereik",
"Select your locality": "Selecteer uw plaats",
"Send Link to Email": "door op de link te klikken die we u zojuist hebben gemaild op ",
"Send the user a notification via email.": "Stuur de gebruiker een melding via e-mail.",
"Sep": "Sep",
"Sep: Checking": "Sep: Controleren",
"Sep: Get": "Sep: Krijg",
"Sep: Update": "Sep: Update",
"September": "September",
"Settings": "Instellingen",
"Setup a unique password to protect your account.": "Stel een uniek wachtwoord in om je account te beschermen.",
"Share": "Delen",
"Share (%)": "Aandeel (%)",
"Show up to": "Kom naar",
"Sign In": "Inloggen",
"Sign Out": "Afmelden",
"Sign Up": "Registreren",
"Sign in": "Inloggen",
"Sign up": "Inschrijven",
"Simple": "Eenvoudig",
"Spanish": "Spaans",
"Spot (60%)": "Spot (60%)",
"Spot Premium Price": "Spot Premieprijs",
"Spot Premium Share": "Spot Premie Aandeel",
"Spot Price": "Spotprijs",
"Spot Prices": "Spotprijzen",
"Spot premium": "Spot premie",
"Spotpris": "Spotpris",
"Start": "Start",
"Start Date": "Startdatum",
"Statement": "Bankafschrift",
"Statement Export": "Verklaring Export",
"Status": "Status",
"Still Loading": "Nog steeds bezig met laden",
"Street": "Straat",
"Submit": "Verzenden",
"Subscription": "Abonnement",
"Subscription Expire At": "Abonnement verloopt op",
"Subscription Expired!": "Abonnement verlopen!",
"Subscription Expiring Soon!": "Abonnement verloopt binnenkort!",
"Subscription Plan": "Abonnement Plan",
"Subscription Plan Name": "Abonnementsplan Naam",
"Subscription Plan added Successfully": "Abonnementsplan succesvol toegevoegd",
"Subscription Plans": "Abonnementsplannen",
"Subscription key, Alpha numeric and dash only": "Inschrijfsleutel, alleen alfanumeriek en streepje",
"Subscription updated Successfully": "Abonnement succesvol bijgewerkt",
"Sum": "Som",
"Sum/Average": "Som/Gemiddelde",
"Support": "Ondersteuning",
"Swedish": "Zweeds",
"Switch as": "Schakelen als",
"System": "Systeem",
"System Partners": "Systeempartners",
"System Price": "Systeemprijs",
"System Roles": "Systeemrollen",
"System Share": "Systeemaandeel",
"System Tariff": "Systeemtarief",
"System Type": "Type systeem",
"System Users": "Systeemgebruikers",
"System kWh": "Systeem kWh",
"TSO - System Subscription": "TSO - Systeemabonnement",
"Take control of your energy expenses with": "Neem controle over uw energiekosten met",
"Tariff": "Tarief",
"Tax": "BTW",
"Taxes (\u00d8re/kWh)": "Belastingen (\u00d8re/kWh)",
"Taxes in (\u00d8re/kWh)": "Belastingen in (\u00d8re/kWh)",
"Tenants": "Tenants",
"Terms & Conditions": "Algemene voorwaarden",
"Test Climate Report": "Rapport testklimaat",
"Test Energy Report": "Energie testrapport",
"Test Sport Price Report": "Test Sport Prijs Rapport",
"Test report": "Testrapport",
"Thank you for registering with us. We're excited to have you on board!": "Bedankt dat je je bij ons hebt geregistreerd. We zijn blij je aan boord te hebben!",
"Thanks for signing up!": "Bedankt voor uw inschrijving!",
"That is great that you know that.": "Dat is geweldig dat je dat weet.",
"The POC has been updated.": "Het POC is bijgewerkt.",
"The cache has been cleared": "De cache is gewist",
"The calculations for the CO2 emissions are based on emissions from each power plant above 10MW and where all power plants below 10MW is regarded as one power plant. Furthermore, the calculations are based on production per hour, consumption per hour and exchange per hour.": "De berekeningen voor de CO2-uitstoot zijn gebaseerd op de uitstoot van elke energiecentrale boven 10MW en waarbij alle energiecentrales onder 10MW als \u00e9\u00e9n energiecentrale worden beschouwd. Verder zijn de berekeningen gebaseerd op productie per uur, verbruik per uur en uitwisseling per uur.",
"The company already linked.": "Het bedrijf is al verbonden.",
"The company has been linked.": "Het bedrijf is gelinkt.",
"The company has been unlinked.": "Het bedrijf is losgekoppeld.",
"The data limit has been updated": "De gegevenslimiet is bijgewerkt",
"The deal has updated": "De deal heeft bijgewerkt",
"The document has been uploaded.": "Het document is ge\u00fcpload.",
"The email has been sent": "De e-mail is verzonden",
"The file has been exported.": "Het bestand is ge\u00ebxporteerd.",
"The historical data limit has been added.": "De historische gegevenslimiet is toegevoegd.",
"The mail already exists in the system!": "De e-mail bestaat al in het systeem!",
"The metering point id from datahub": "De meetpunt-id van datahub",
"The module has been updated": "De module is bijgewerkt",
"The new POC has been added.": "Het nieuwe POC is toegevoegd.",
"The new deal has added": "De nieuwe deal heeft toegevoegd",
"The new feature has been added": "De nieuwe functie is toegevoegd",
"The new module has been added": "De nieuwe module is toegevoegd",
"The new partner has been added.": "De nieuwe partner is toegevoegd.",
"The new role has been added.": "De nieuwe rol is toegevoegd.",
"The new user has been added.": "De nieuwe gebruiker is toegevoegd.",
"The partner has been updated.": "Partnergebruikers voor  ",
"The password has been reset.": "Het wachtwoord is opnieuw ingesteld.",
"The password has been updated.": "Het wachtwoord is bijgewerkt.",
"The registration is by invitation only.": "De registratie is alleen op uitnodiging.",
"The role has been updated": "De rol is bijgewerkt",
"The session has been expired.": "De sessie is verlopen.",
"The system is now creating the report, and you can download it shortly by clicking Download.": "Het systeem maakt het rapport nu aan en je kunt het binnenkort downloaden door op Downloaden te klikken.",
"The user already linked.": "De gebruiker is al gelinkt.",
"The user has been linked.": "De gebruiker is gekoppeld.",
"The user has been unlinked.": "De gebruiker is ontkoppeld.",
"The user has been updated": "De gebruiker is bijgewerkt",
"The year cache has been updated": "De jaarcache is bijgewerkt",
"There are no documents matching your criteria.": "Er zijn geen documenten die aan uw criteria voldoen.",
"These terms and conditions outline the rules and regulations for the use of Fabeke's Website, located at https://www.fabeke.com": "In deze algemene voorwaarden worden de regels en voorschriften beschreven voor het gebruik van de website van Fabeke, die te vinden is op https://www.fabeke.com",
"Third Party Privacy Policies": "Privacybeleid van derden",
"Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Fabeke, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.": "Advertentieservers van derden of advertentienetwerken maken gebruik van technologie\u00ebn zoals cookies, JavaScript of webbakens die worden gebruikt in hun respectieve advertenties en links die worden weergegeven op Fabeke en die rechtstreeks naar de browser van de gebruiker worden verzonden. Zij ontvangen automatisch uw IP-adres wanneer dit gebeurt. Deze technologie\u00ebn worden gebruikt om de effectiviteit van hun reclamecampagnes te meten en/of om de reclame-inhoud die u te zien krijgt op websites die u bezoekt, te personaliseren.",
"This area is forbidden. Turn back now!": "Dit gebied is verboden. Keer nu om!",
"This is a heads-up, everyone! We've temporarily paused new registrations. But don't worry, we'll open them again shortly. Stay tuned!": "Dit is een waarschuwing, iedereen! We hebben nieuwe registraties tijdelijk onderbroken. Maar maak je geen zorgen, we openen ze binnenkort weer. Blijf op de hoogte!",
"Thumbnail View": "Miniatuurafbeelding",
"Time Zone": "Tijdzone",
"Timestamp of last encountered when requesting data from datahub": "Tijdstempel van laatst gevonden bij het opvragen van gegevens van datahub",
"Timezone": "Tijdzone",
"To": "Tot",
"To complete your registration and activate your account, please confirm your email address by clicking the below:": "Om je registratie te voltooien en je account te activeren, moet je je e-mailadres bevestigen door op het onderstaande te klikken:",
"To date is required": "Tot op heden is vereist",
"To ensure the data is tailored to your local time, we require your": "Om ervoor te zorgen dat de gegevens zijn afgestemd op uw lokale tijd, hebben we uw",
"Total Electricity Charge": "Totale elektriciteitskosten",
"Translation": "Vertaling",
"Transmission Grid Tariff": "Tarief transportnet",
"Type": "Type",
"Type of meter. E17 = consumption, E18 = production": "Type meter. E17 = verbruik, E18 = productie",
"URL": "URL",
"Under construction": "In aanbouw",
"Unit": "Eenheid",
"Unknown Error Occurred !": "Onbekende fout opgetreden!",
"Unknown error1 Occurred !": "Onbekende fout 1 opgetreden!",
"Unlink": "Verbreek koppeling",
"Update": "Bijwerken",
"Update Roles": "Rollen bijwerken",
"Update failed": "Bijwerken mislukt",
"Update your Image and other data here.": "Werk hier je afbeelding en andere gegevens bij.",
"Updated At": "Bijgewerkt op",
"Updating...": "Bijwerken...",
"Upload": "Uploaden",
"Upload Data": "Gegevens uploaden",
"Upload Document Files": "Documentbestanden uploaden",
"Upload New Document": "Nieuw document uploaden",
"Upload New Document File (Optional)": "Nieuw documentbestand uploaden (optioneel)",
"Upload PO file": "Upload PO-bestand",
"Upload Po file": "Po-bestand uploaden",
"Uploaded": "Geupload",
"Uploading": "Bezig met uploaden",
"Uploading...": "Uploading...",
"Use this page to update the application version. Once you change the version, the client-side application will automatically download and run the latest code from the server.": "Gebruik deze pagina om de applicatieversie bij te werken. Zodra je de versie wijzigt, zal de client-side applicatie automatisch de nieuwste code downloaden en uitvoeren vanaf de server.",
"Used:": "Gebruikt:",
"User Data": "Gebruikersgegevens",
"User ID is missing": "Gebruikers-ID ontbreekt",
"Users": "Gebruikers",
"Users for the business: ": "Gebruikers voor het bedrijf: ",
"Users for the corporate group: ": "Gebruikers voor de bedrijfsgroep: ",
"V_per_m2": "V_per_m2",
"Validating period": "Validatieperiode",
"Validating. Please wait.": "Bezig met valideren. Even geduld a.u.b.",
"Validity end date": "Einddatum geldigheid",
"Validity start date": "Begindatum geldigheid",
"Variable/Spot/Nordpool price": "Variabel/Spot/Nordpool prijs",
"Verification Successful": "Verificatie succesvol",
"Verify Password": "Verifieer wachtwoord",
"Version": "Versie",
"Version Management": "Versiebeheer",
"View": "Bekijk",
"View Mode": "Weergavemodus",
"View meter details": "Bekijk meter details",
"Water": "Water",
"We are unable to find your email address": "We kunnen uw e-mailadres niet vinden",
"We couldn't find what you searched for": "We konden niet vinden wat u zocht",
"We employ the use of cookies. By accessing Fabeke, you agreed to use cookies in agreement with the Fabeke's Privacy Policy.": "Wij maken gebruik van cookies. Door Fabeke te bezoeken, gaat u akkoord met het gebruik van cookies in overeenstemming met het privacybeleid van Fabeke.",
"We have updated the reports for last month, and you can download the reports by clicking below": "We hebben de rapporten van de afgelopen maand bijgewerkt en je kunt ze downloaden door hieronder te klikken",
"Website": "Website",
"Welcome to": "Welkom bij",
"Welcome to ": "Welkom bij ",
"What do you know?": "Wat weet je?",
"Wrong password!": "Verkeerd wachtwoord!",
"Year": "Jaar",
"Year Data: Downloading": "Jaargegevens: Downloaden",
"Year Data: Processing": "Jaargegevens: Verwerking",
"Year Report - Under development": "Jaarverslag - In ontwikkeling",
"Year: Get": "Jaar: Get",
"Year: Update": "Jaar: Update",
"Yearly": "Jaarlijks",
"Years": "Jaren",
"Yes": "Ja",
"Yes I know that.": "Ja, dat weet ik.",
"You are not authorized to perform this action": "U bent niet gemachtigd om deze actie uit te voeren",
"You can change your password here": "U kunt uw wachtwoord hier wijzigen",
"You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browser's respective websites.": "U kunt ervoor kiezen om cookies uit te schakelen via de opties van uw individuele browser. Meer gedetailleerde informatie over het beheer van cookies met specifieke webbrowsers vindt u op de respectievelijke websites van de browsers.",
"You can continue to use our services now. ": "Je kunt nu gebruik blijven maken van onze diensten. ",
"You can now use your new password to sign in to your account.": "Je kunt nu je nieuwe wachtwoord gebruiken om je aan te melden bij je account.",
"You can upload only the PO file. After uploading that file, it takes almost 10 minutes to reflect the changes on the website.": "Je kunt alleen het PO-bestand uploaden. Na het uploaden van dat bestand duurt het bijna 10 minuten om de wijzigingen op de website weer te geven.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Je bent door {{partner_name}} uitgenodigd om lid te worden als {{role_name}}. Om door te gaan, klik je op Inloggen om toegang te krijgen tot het systeem.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "U bent uitgenodigd door de {{partner_name}} om mee te doen als {{role_name}}. Om verder te gaan, moet je een wachtwoord aanmaken om toegang te krijgen tot het systeem.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Je bent door {{tenant_name}} uitgenodigd om lid te worden als {{role_name}}. Om door te gaan, klik je op Inloggen om toegang te krijgen tot het systeem.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "U bent uitgenodigd door de {{tenant_name}} om mee te doen als {{role_name}}. Om verder te gaan, moet je een wachtwoord aanmaken om toegang te krijgen tot het systeem.",
"Your Picture": "Uw foto",
"Your account doesn\u2019t exist, please Sign Up": "Je account bestaat niet, meld je aan",
"Your login session has been expired. Please log in again": "Uw inlogsessie is verlopen. Log opnieuw in",
"Your password has been changed": "Uw wachtwoord is gewijzigd",
"Your password has been successfully reset.": "Uw wachtwoord is succesvol gereset.",
"Your private file": "Uw priv\u00e9bestand",
"Your profile has been updated": "Je profiel is bijgewerkt",
"Your subscription has expired. Renew now to regain access to your account and all premium features.": "Uw abonnement is verlopen. Verleng nu om weer toegang te krijgen tot uw account en alle premiumfuncties.",
"Your subscription will expire in": "Uw abonnement verloopt over",
"Zip Code": "Postcode",
"aggregated": "geaggregeerd",
"all": "alle",
"and": "en",
"and Fabeke Tech does not take responsibility for any errors in submitted data and lists": "en Fabeke Tech neemt geen verantwoordelijkheid voor eventuele fouten in ingediende gegevens en lijsten",
"browse": "blader",
"cache has been updated": "cache is bijgewerkt",
"clicking the link we just emailed you at ": "door op de link te klikken die we u zojuist hebben gemaild op ",
"collects your energy data, prices and carbon emissions from all relevant data sources and present your energy consumption, prices, taxes, costs, and carbon emissions in our energy spending platform.": "verzamelt je energiegegevens, prijzen en koolstofuitstoot uit alle relevante gegevensbronnen en presenteert je energieverbruik, prijzen, belastingen, kosten en koolstofuitstoot in ons platform voor energiekosten.",
"comprehensive data and insights": "uitgebreide gegevens en inzichten",
"contact us": "neem contact met ons op",
"converts data into your language and local time zone": "converteert gegevens naar jouw taal en lokale tijdzone",
"country, timezone and corporate group": "land, tijdzone en bedrijfsgroep",
"does not take responsibility for any errors in submitted data and lists": "aanvaardt geen verantwoordelijkheid voor fouten in ingediende gegevens en lijsten",
"export": "exporteer",
"export to CSV": "exporteren naar CSV",
"export to Excel": "exporteren naar Excel",
"export to PDF": "exporteren naar PDF",
"files": "bestanden",
"for any queries.": "voor vragen.",
"g CO\u2082/kW": "g CO\u2082/kW",
"g CO\u2082e/kW": "g CO\u2082e/kW",
"gives you": "geeft je",
"https://www.example.com": "https://www.example.com",
"into your energy usage, costs, and carbon footprint.": "in je energieverbruik, kosten en ecologische voetafdruk.",
"kWh": "kWh",
"measuring the Carbon dioxide Consumption. potential difference across a surface area, we use the unit carbon dioxide per square meter (Co2/m2)": "om het potentiaalverschil over een oppervlakte te meten, gebruiken we de eenheid kooldioxide per vierkante meter (Co2/m2)",
"measuring the electrical potential difference across a surface area, we use the unit volts per square meter (V/m2)": "om het elektrische potentiaalverschil over een oppervlakte te meten, gebruiken we de eenheid volt per vierkante meter (V/m2)",
"or": "of",
"page": "pagina",
"q": "q",
"real-time, accurate insights": "realtime, nauwkeurige inzichten",
"ubscription Expire A": "Abonnement verloopt A",
"v": "v"
},
"plural": "0"
}